/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from 'react';
import toast from 'cogo-toast';
import Cookies from 'js-cookie';
import { Page, Form, Button, Card, Site } from 'tabler-react';

import logo from '../../assets/brand_logo.svg';
import Request from '../../shared/request';
import './forgot.scss';
import PageComponent from '../PageComponent';

class Forgot extends PageComponent {
  state = {
    isProcessing: false,
    email: '',
    phone: '',
    areacode: '86',
    passcode: '',
    captcha: '',
    captchaValue: '',
    captchaToken: '',
    tab: 'email',
  };

  handleSendPasscode = async event => {
    event.preventDefault();
    if (this.state.clock > 0) {
      toast.warn('请稍后再发送');
    }
    if (!this.state.email && !this.state.phone) {
      return toast.warn('请输入邮箱或者手机号');
    }
    this.setState({ captcha: '' });
    const body = {
      type: this.state.tab,
      from: 'RESET_PASSWORD',
    };
    if (this.state.tab === 'email') {
      body.email = this.state.email;
    } else {
      body.phone = `+${this.state.areacode}${this.state.phone}`;
    }
    if (this.state.captchaValue) {
      body.captcha = this.state.captchaValue;
      body.captchaToken = this.state.captchaToken;
    }
    const res = await Request.call('sendPasscode', body);
    if (res.code === 11138) {
      const { captchaToken, captcha } = res.data;
      return this.setState({ captcha, captchaToken });
    }
    if (res) {
      toast.success('验证码已发送,60s后可重新获取', 3);
      this.setState({ clock: 60 });
      this.timer = setInterval(() => {
        this.setState(prevState => {
          const newState = { clock: prevState.clock - 1 };
          if (prevState.clock <= 1) {
            clearInterval(this.timer);
          }
          return newState;
        });
      }, 1000);
    }
  };

  handleResetPassword = async event => {
    event.preventDefault();
    this.setState({ isProcessing: true });
    const body = {
      passcode: this.state.passcode,
      newPassword: this.state.newPassword,
      confirmPassword: this.state.confirmPassword,
    };
    if (this.state.tab === 'email') {
      body.email = this.state.email;
    } else {
      body.phone = `+${this.state.areacode}${this.state.phone}`;
    }
    if (!body.passcode || !body.newPassword) {
      this.setState({ isProcessing: false });
      return toast.warn('参数错误');
    }
    const userInfo = await Request.call('resetUserPassword', body);
    this.setState({ isProcessing: false });
    if (userInfo) {
      this.saveToken(userInfo);
      window.location.href = '/dashboard';
    }
  };

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('miao-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
  };

  renderInputs = () => (
    <div>
      {this.state.captcha ? (
        <div className="captcha">
          <div className="content">
            <div className="header">
              <div className="title">安全验证</div>
              <i
                className="ri-close-circle-line"
                onClick={() => this.setState({ captcha: null })}
              />
            </div>
            <div className="body">
              <img
                src={`data:image/png;base64,${this.state.captcha}`}
                onClick={this.handleSendPasscode}
                alt="code"
              />
              <Form.Input
                onChange={e => this.setState({ captchaValue: e.target.value })}
                type="text"
                autoComplete="off"
                value={this.state.captchaValue}
                placeholder="请输入安全码"
              />
              <Button
                className="miao-setting-btn"
                type="submit"
                color="primary"
                onClick={this.handleSendPasscode}>
                完成验证
              </Button>
            </div>
          </div>
        </div>
      ) : (
          ''
        )}
      <div className="bind-tab">
        <h3
          onClick={() => this.setState({ tab: 'email' })}
          className={this.state.tab === 'email' ? 'active' : ''}>
          邮箱重置
        </h3>
        <h3
          onClick={() => this.setState({ tab: 'phone' })}
          className={this.state.tab === 'phone' ? 'active' : ''}>
          手机号重置
        </h3>
      </div>
      {this.state.tab === 'email' ? (
        <Form.Group>
          <Form.InputGroup>
            <Form.Input
              placeholder="请输入绑定的邮箱"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
            />
            <Form.InputGroupAppend>
              <Button
                RootComponent="div"
                color="primary"
                disabled={this.state.isProcessing ? 'disanled' : ''}
                onClick={this.handleSendPasscode}>
                {this.state.clock > 0 ? `${this.state.clock} S` : '发送验证码'}
              </Button>
            </Form.InputGroupAppend>
          </Form.InputGroup>
        </Form.Group>
      ) : (
          <Form.Group>
            <Form.InputGroup className="phone-group">
              <span className="plus">+</span>
              <Form.Input
                placeholder="区号"
                value={this.state.areacode}
                onChange={e => this.setState({ areacode: e.target.value })}
                className="area"
              />
              <Form.Input
                placeholder="输入绑定手机号"
                value={this.state.phone}
                onChange={e => this.setState({ phone: e.target.value })}
                className="number"
              />
              <Form.InputGroupAppend>
                <Button
                  RootComponent="div"
                  color="primary"
                  disabled={this.state.isProcessing ? 'disanled' : ''}
                  onClick={this.handleSendPasscode}>
                  {this.state.clock > 0 ? `${this.state.clock} S` : '发送验证码'}
                </Button>
              </Form.InputGroupAppend>
            </Form.InputGroup>
          </Form.Group>
        )}
      <Form.Input
        placeholder="输入验证码"
        type="text"
        autoComplete="off"
        onChange={e => this.setState({ passcode: e.target.value })}
      />
      <Form.Input
        placeholder="输入密码"
        type="password"
        autoComplete="off"
        onChange={e => this.setState({ newPassword: e.target.value })}
      />
      <Form.Input
        autoComplete="off"
        placeholder="再次输入密码"
        type="password"
        onChange={e => this.setState({ confirmPassword: e.target.value })}
      />
      <Button
        type="submit"
        className="malus-loading"
        disabled={this.state.isProcessing}
        block
        onClick={this.handleResetPassword}
        color="primary">
        重置密码
      </Button>
    </div>
  );

  render() {
    return (
      <Page className="miao-login">
        <Card className="form-card">
          <Card.Header>
            <Site.Logo src={logo} />
            <span>重置密码</span>
          </Card.Header>
          <Card.Body className="miao-forgot">{this.renderInputs()}</Card.Body>
        </Card>
      </Page>
    );
  }
}

export default Forgot;
